<template lang="pug">
base-layout
  template(v-slot:before-footer)
    k-landing-how-can-you-use-kintell.mt-10
</template>

<script>
import BaseLayout from '@/layouts/base'
export default {
  components: {
    BaseLayout
  },
}
</script>

<style scoped>

</style>
